import {
  FETCH_ALL_REPORTS,
  FETCH_REPORT,
  CREATE_REPORT,
  UPDATE_REPORT,
  DELETE_REPORT,
} from "../types";

const initialState = {
  loading: false,
  message: null,
  data: [],
};

export const reportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_ALL_REPORTS}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_ALL_REPORTS}_FULFILLED`:
      const result = action.payload.data ? action.payload.data.results : [];
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data?.message || "",
      };

    case `${FETCH_ALL_REPORTS}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_REPORT}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_REPORT}_FULFILLED`:
      const result = action.payload.data.results
        ? action.payload.data.results
        : {};
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data.message,
      };

    case `${FETCH_REPORT}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const createReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${CREATE_REPORT}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${CREATE_REPORT}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
      };

    case `${CREATE_REPORT}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const updateReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${UPDATE_REPORT}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${UPDATE_REPORT}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${UPDATE_REPORT}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const deleteReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${DELETE_REPORT}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${DELETE_REPORT}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload ? action.payload : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${DELETE_REPORT}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};
